import type { BoApiBaseUrlVersion } from 'apps/core/vars/services';

type GetBoApiBasePathOptions = {
  version?: BoApiBaseUrlVersion;
};

export const getBoApiBasePath = (path?: string, options?: GetBoApiBasePathOptions) => {
  const defaultOptions: GetBoApiBasePathOptions = {};

  const { version } = { ...defaultOptions, ...(options ?? {}) };

  const baseUrl = '/paymentiq/backoffice/api';

  const versionSection = version !== undefined ? `/${version}` : '';

  return `${baseUrl}${versionSection}${path}`;
};
